import { memo } from 'react';
import { MATCH_STATUS } from '@zmedia/bm-soccer-ui/constants';
import { IStatus } from '@zmedia/bm-soccer-ui/interface';
import { Element } from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

interface IProps {
    status: IStatus;
    minute?: string;
    children?: React.ReactNode;
}
export function Status({ status, minute, children }: IProps) {
    const renderStatus = () => {
        switch (status.id) {
            case MATCH_STATUS.HT:
                return (
                    <Element renderAs="span" style={{ color: '#f00c' }}>
                        Hết hiệp 1
                    </Element>
                );
            case MATCH_STATUS.FT:
                return <>Kết thúc</>;
            case MATCH_STATUS.LIVE:
            case MATCH_STATUS.PS:
            case MATCH_STATUS.ET:
                return (
                    <>
                        <Element className={styles['is-live']}></Element>
                        <Element renderAs="span"> {minute}</Element>
                    </>
                );
            case MATCH_STATUS.POSTPONED:
                return <>Hoãn</>;
            default:
                return <></>;
        }
    };

    return (
        <Element className={styles['status']}>
            {children ? children : renderStatus()}
        </Element>
    );
}

export default memo(Status);
